// extracted by mini-css-extract-plugin
export default {"langIcon":"Language_langIcon__Z3mtg"};